import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ActiveWebsitePage } from '../types/ActiveWebsitePageEnum';

interface NavigationState {
  activePage: ActiveWebsitePage;
}

const initialState: NavigationState = {
  activePage: ActiveWebsitePage.Home,
};

const navigationSlice = createSlice({
  name: 'navigation',
  initialState,
  reducers: {
    setActivePage: (state, action: PayloadAction<ActiveWebsitePage>) => {
      state.activePage = action.payload;
    },
  },
});

export const { setActivePage } = navigationSlice.actions;
export default navigationSlice.reducer;